import $ from 'cash-dom';

/**
 * This module adds `active` class to InputField divs when inputs are focused or filled
 */
export class FormModule {

    static name = 'form';

    constructor(node) {

        this.node = node;

        $(node).on('focus', 'input, textarea', this.handleFocus);
        $(node).on('blur', 'input, textarea', this.handleBlur);
    }

    handleFocus = (e) => {
        $(e.currentTarget)
        .closest('.Inputfield')
        .addClass('active');
    }

    handleBlur = (e) => {
        if(!e.currentTarget.value) {
            $(e.currentTarget)
            .closest('.Inputfield')
            .removeClass('active');
        }
    }
}